import { authenticatedFetch } from "./apiClient";

const parseError = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || fallback);
  }
  return data;
};

export const fetchDotPhrases = async () => {
  const response = await authenticatedFetch("/dotphrases/all");
  return parseError(response, "Failed to fetch dotphrases");
};

export const getDotPhrase = async (abbreviation) => {
  const response = await authenticatedFetch(
    `/dotphrases/get?abbreviation=${encodeURIComponent(abbreviation)}`
  );
  if (response.status === 404) return null;
  return parseError(response, "Failed to fetch dotphrase");
};

export const addDotPhrase = async ({ text, abbreviation, specialty = "general" }) => {
  const response = await authenticatedFetch("/dotphrases/add", {
    method: "POST",
    body: JSON.stringify({
      user_id: "self",
      text,
      abbreviation,
      specialty,
      source: "user",
      times_used: 0,
    }),
  });
  return parseError(response, "Failed to add dotphrase");
};

export const updateDotPhrase = async (_id, { text, abbreviation, specialty = "general", times_used = 0 }) => {
  const response = await authenticatedFetch("/dotphrases/update", {
    method: "PUT",
    body: JSON.stringify({
      _id,
      dotphrase: {
        user_id: "self",
        text,
        abbreviation,
        specialty,
        source: "user",
        times_used,
      },
    }),
  });
  return parseError(response, "Failed to update dotphrase");
};

export const deleteDotPhrase = async (_id) => {
  const response = await authenticatedFetch("/dotphrases/delete", {
    method: "DELETE",
    body: JSON.stringify({ _id }),
  });
  return parseError(response, "Failed to delete dotphrase");
};
